<div class="right-panel h-100">
  <div class="right-side">
    <!--<p *ngIf="!available" style="align-self:center; margin-top:20%">No Active Session</p>-->
    <div class="sessionList d-flex flex-column h-100">
      <div class="actionBar d-flex">
        <input
          class="search"
          type="text"
          placeholder="Search by name or IP Address"
          [(ngModel)]="filterText"
        />

        <button
          type="button"
          class="actionBtn"
          (click)="refreshComponent()"
          style="height: 30px"
          triggers="hover"
          ngbTooltip="Refresh Details"
        >
          <span class="bi bi-arrow-clockwise"></span>
        </button>

        <button type="button"
                class="actionBtn"
                [ngbPopover]="filterContent"
                #filterPopover="ngbPopover"
                [autoClose]="'outside'"
                popoverClass="filter-popover"
                container="body"
                placement="top auto"
                (mouseenter)="tooltipInstance.open()"
                (mouseleave)="tooltipInstance.close()"
                [ngbTooltip]="'Show/Hide Filters'"
                #tooltipInstance="ngbTooltip">
          <span class="bi bi-funnel"></span>
          <span class="position-absolute top-0 start-100 badge rounded-pill"
                *ngIf="getActiveFiltersCount() > 0">
            {{ getActiveFiltersCount() }}
            <span class="visually-hidden">active filters</span>
          </span>
        </button>

        <button
          class="actionBtn"
          style="
            margin-top: 6px;
            margin-left: 4px;
            font-size: x-large;
            height: 1.875rem;
          "
          (click)="editColoum()"
          triggers="hover"
          ngbTooltip="Edit Columns"
        >
          <span>
            <i
              class="bi bi-sliders"
              style="font-size: x-large; margin-right: 0px"
            ></i>
          </span>
        </button>

        <button
          class="actionBtn"
          style="align-content: center; padding-right: 8px"
          (click)="connectVdiNode()"
          triggers="hover"
          ngbTooltip="Request New Session"
        >
          <span class="bi bi-pc-display-horizontal"></span>
          <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
        </button>
      </div>
      <!-- Session Filter Button with Popover - Using your exact HTML select elements -->


<!-- Filter Popover Content Template -->
<ng-template #filterContent>
  <div class="filter-container">
    <div class="filter-section">
      <label>Deployment</label>
      <div class="field-container">
        <select
          name="deployment"
          class="searchFilter"
          [(ngModel)]="filterDeployment"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterDeployment == 'All'">
            All Deployment
          </option>
          <option *ngFor="let n of depList" value="{{ n }}">{{ n }}</option>
        </select>
      </div>
    </div>

    <div class="filter-section">
      <label>OS</label>
      <div class="field-container">
        <select
          name="os"
          class="searchFilter"
          [(ngModel)]="filterOs"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterOs == 'All'">
            All OS
          </option>
          <option value="WINDOWS">WINDOWS</option>
          <option value="LINUX">LINUX</option>
        </select>
      </div>
    </div>

    <div class="filter-section">
      <label>Protocol</label>
      <div class="field-container">
        <select
          name="protocol"
          class="searchFilter"
          [(ngModel)]="filterProtocol"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterProtocol == 'All'">
            All Protocols
          </option>
          <option value="0">RDP</option>
          <option value="1">PCoIP</option>
          <option value="2">DCV</option>
        </select>
      </div>
    </div>

    <div class="filter-section">
      <label>State</label>
      <div class="field-container">
        <select
          name="sessionState"
          class="searchFilter"
          [(ngModel)]="filterSessionState"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterSessionState == 'All'">
            All States
          </option>
          <option *ngFor="let n of avlSessionStatesForFilter" value="{{ n }}">
            {{ n }}
          </option>
          <option
            value="ReadyRequested"
            [selected]="filterSessionState == 'ReadyRequested'"
          >
            Ready/Requested
          </option>
        </select>
      </div>
    </div>

    <div class="filter-section">
      <label>User</label>
      <div class="field-container">
        <select
          name="user"
          class="searchFilter"
          [(ngModel)]="filterUser"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterUser == 'All'">
            All Users
          </option>
          <option *ngFor="let n of avlUserForFilter" value="{{ n }}">
            {{ n }}
          </option>
        </select>
      </div>
    </div>

    <div class="filter-section">
      <label>Nodes</label>
      <div class="field-container">
        <select
          name="nodes"
          class="searchFilter"
          [(ngModel)]="filterVms"
          (ngModelChange)="applyFilter()"
        >
          <option value="All" [selected]="filterVms == 'All'">
            All Nodes
          </option>
          <option *ngFor="let n of avlVMsForFilter" value="{{ n }}">
            {{ n ? n : "NA" }}
          </option>
        </select>
      </div>
    </div>

    <button type="button"
            class="reset-button"
            title="Reset applied filters"
            (click)="resetFilter(); filterPopover.close()"
            triggers="hover"
            ngbTooltip="Reset Filters">
      <span class="bi bi-arrow-counterclockwise reset-icon"></span>
      Reset Filters
    </button>
  </div>
</ng-template>

      <div class="listTable h-100">
        <div class="x w-100" [class.h-100]="available" style="overflow-y: auto">
          <table
            class="table table-hover table-condensed"
            cellspacing="0"
            id="sessionInfoList"
            style="border-collapse: collapse; white-space: nowrap"
          >
            <thead>
              <tr
                style="
                  color: White;
                  background-color: var(--s-primary-color);
                  height: 22px;
                "
              >
                <th resizable scope="col">
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >#</a
                  >
                </th>
                <th resizable scope="col">
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Session Name
                    <span
                      style="cursor: pointer"
                      (click)="sortSessionName()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        nameSessionSort
                          ? 'bi-arrow-up-short'
                          : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th resizable scope="col">
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Session State
                    <span
                      style="cursor: pointer"
                      (click)="sortSessionState()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        serialNoSort
                          ? 'bi-arrow-up-short'
                          : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('IP')"
                >
                  IP
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('User')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    User
                    <span
                      style="cursor: pointer"
                      (click)="sortUser()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        userSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Full Name')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Full Name
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Login Time')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Login Time
                    <span
                      style="cursor: pointer"
                      (click)="sortDate()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        loginTimeSort
                          ? 'bi-arrow-up-short'
                          : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Expiration Time')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >Expiration Time</a
                  >
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Idle Time')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Idle Time
                    <span
                      style="cursor: pointer"
                      (click)="sortIdleTime()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        idleTimeSort
                          ? 'bi-arrow-up-short'
                          : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Duration')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                  >
                    Duration
                    <span
                      style="cursor: pointer"
                      (click)="sortDuration()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                        durationSort
                          ? 'bi-arrow-up-short'
                          : 'bi-arrow-down-short'
                      "
                      class="bi"
                    ></span>
                  </a>
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Deployment')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >Deployment</a
                  >
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('RdProtocol')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >RdProtocol</a
                  >
                </th>
                <th
                  scope="col"
                  *ngIf="editedColumnList.includes('CPU %')"
                  width="7%"
                  resizable
                  title="Average usage of CPU"
                >
                  CPU %
                </th>
                <th
                  scope="col"
                  *ngIf="editedColumnList.includes('RAM %')"
                  width="7%"
                  resizable
                  title="Average usage of RAM"
                >
                  RAM %
                </th>
                <th
                  scope="col"
                  *ngIf="editedColumnList.includes('GPU %')"
                  width="7%"
                  resizable
                  title="Average usage of GPU"
                >
                  GPU %
                </th>
                <th
                  resizable
                  scope="col"
                  *ngIf="editedColumnList.includes('Session Apps')"
                >
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >Session Apps</a
                  >
                </th>
                <th resizable scope="col" *ngIf="isMonitor == false">
                  <a
                    style="color: White; text-decoration: none; cursor: default"
                    >Actions</a
                  >
                </th>
              </tr>
            </thead>
            <tbody *ngIf="available">
              <tr
                style="cursor: pointer; height: 22px !important"
                [ngClass]="{
                  highlightClickedRow: tempSessionName == session.name
                }"
                *ngFor="
                  let session of filteredSessions
                    | sessionListFilter : filterText;
                  let i = index
                "
              >
                <td style="cursor: pointer" scope="row">{{ i + 1 }}</td>
                <td style="cursor: pointer" scope="row">
                  {{ session.name }}
                  <i
                    *ngIf="getToolTipForSession(session)"
                    class="bi bi-info-circle-fill synchpc-primary float-end pe-4"
                    placement="bottom-left"
                    container="body"
                    [autoclose]="true"
                    (mouseover)="getToolTipForSession(session)"
                    triggers="hover"
                    [ngbTooltip]="sesiontooltip"
                  >
                  </i>
                </td>
                <td style="cursor: pointer" scope="row">
                  {{ session.state | slice : 3 }}
                </td>
                <td *ngIf="editedColumnList.includes('IP')">
                  {{ session.ip }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('User')"
                >
                  {{ session.user }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('Full Name')"
                >
                  {{ session.userName || "NA" }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('Login Time')"
                >
                  {{ session.loginTime | date : "yyyy-MM-dd HH:mm:ss" }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('Expiration Time')"
                >
                  {{
                    session.expirationTime
                      ? (session.expirationTime | date : "yyyy-MM-dd HH:mm:ss")
                      : "NA"
                  }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('Idle Time')"
                >
                  {{ session.idleTime }}
                </td>
                <td
                  style="cursor: pointer"
                  title="Actual use out of {{ session.totalDuration }}"
                  *ngIf="editedColumnList.includes('Duration')"
                >
                  {{ session.duration }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('Deployment')"
                >
                  {{ session.referenceDepName }}
                </td>
                <td
                  style="cursor: pointer"
                  *ngIf="editedColumnList.includes('RdProtocol')"
                >
                  {{ session.rdProtocolName }}
                </td>
                <td *ngIf="editedColumnList.includes('CPU %')">
                  <div
                    class="progress"
                    title="{{ session.sessionStats.cpuUtilization }}%"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      [style.width.%]="session.sessionStats.cpuUtilization"
                    ></div>
                    <span
                      class="progressValue"
                      [style.width.%]="session.sessionStats.cpuUtilization"
                    >
                      {{
                        session.sessionStats.cpuUtilization
                          ? session.sessionStats.cpuUtilization
                          : 0
                      }}%
                    </span>
                  </div>
                </td>
                <td *ngIf="editedColumnList.includes('RAM %')">
                  <div
                    class="progress"
                    title="{{ session.sessionStats.ramUtilization }}%"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      [style.width.%]="session.sessionStats.ramUtilization"
                    ></div>
                    <span
                      class="progressValue"
                      [style.width.%]="session.sessionStats.ramUtilization"
                    >
                      {{
                        session.sessionStats.ramUtilization
                          ? session.sessionStats.ramUtilization
                          : 0
                      }}%
                    </span>
                  </div>
                </td>
                <td *ngIf="editedColumnList.includes('GPU %')">
                  <div
                    class="progress"
                    title="{{ session.sessionStats.gpuUtilization }}%"
                  >
                    <div
                      class="progress-bar"
                      role="progressbar"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      [style.width.%]="session.sessionStats.gpuUtilization"
                    ></div>
                    <span
                      class="progressValue"
                      [style.width.%]="session.sessionStats.gpuUtilization"
                    >
                      {{
                        session.sessionStats.gpuUtilization
                          ? session.sessionStats.gpuUtilization
                          : 0
                      }}%
                    </span>
                  </div>
                </td>
                <td
                  class="synchpc-primary"
                  style="cursor: pointer"
                  width="12%"
                  *ngIf="editedColumnList.includes('Session Apps')"
                >
                  <select style="width: 100%">
                    <option *ngFor="let app of session.apps; let n = index">
                      {{ n + 1 }}. {{ app }}
                    </option>
                  </select>
                </td>
                <td style="cursor: pointer">
                  <button
                    class="connect-button"
                    *ngIf="permissionToConnect(session)"
                    (click)="connectSession(session)"
                    [ngStyle]="{
                      'pointer-events':
                        session.state != 'WTSRequested' ? 'auto' : 'none'
                    }"
                  >
                    <span
                      class="bi bi-link"
                      style="color: var(--s-primary-color); font-size: larger"
                      title="Connect to on-going session"
                      [ngStyle]="{
                        opacity: session.state != 'WTSRequested' ? '1' : '0.2'
                      }"
                    >
                    </span>
                  </button>
                  <span
                    class="bi bi-plus-circle p-2"
                    style="color: var(--s-primary-color); font-size: large"
                    title="Extend on-going sessions"
                    [matMenuTriggerFor]="extendMenu"
                    *ngIf="permissionToConnect(session) && !hasMaxSessionTime"
                  >
                  </span>
                  <span
                    class="bi bi-box-arrow-right"
                    style="color: var(--s-primary-color); font-size: large"
                    title="Remove on-going sessions"
                    *ngIf="isMonitor == false"
                    (click)="removeSession(session)"
                  >
                  </span>
                  <mat-menu #extendMenu="matMenu">
                    <button
                      *ngFor="let hrs of timePeriod"
                      (click)="extendSessionTime(session, hrs)"
                      mat-menu-item
                    >
                      {{ hrs }} Hr
                    </button>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--   <pagination-controls *ngIf="available"
                      class="my-pagination"
                      (pageChange)="p = $event" style="padding-bottom: 1.5rem;">
      </pagination-controls>-->
        <p id="emptyError" *ngIf="available == false">No sessions found.</p>
      </div>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
  >
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>
<ng-template #sesiontooltip>
  <div
    class="tooltipNodeName"
    style="text-align: left"
    [innerHTML]="sessionTooltipHtml | safeHtml"
  ></div>
</ng-template>
